module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "loading d-flex justify-content-center"
  }, [_c('vueSpinner', {
    staticClass: "align-self-center"
  })], 1) : _vm._e(), _vm._v(" "), (_vm.errorMessage !== '') ? _c('modal', {
    staticClass: "systemModal",
    attrs: {
      "top": true,
      "styleObject": {
        'width': '60vh'
      }
    },
    on: {
      "close": function($event) {
        _vm.setErrorMessage('')
      }
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v(_vm._s(_vm.$t('message')))]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_vm._v("\n      " + _vm._s(_vm.$t(_vm.errorMessage) ? _vm.$t(_vm.errorMessage) : _vm.errorMessage) + "\n    ")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.setErrorMessage('')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('yes')))])])]) : _vm._e(), _vm._v(" "), (_vm.$route.path !== '/' && _vm.$route.path !== '/login') ? _c('nav', {
    ref: "navbar",
    staticClass: "navbar navbar-expand-lg navbar-light bg-white sticky-top border-primary p-0",
    style: ({
      'border-bottom': '5px solid'
    })
  }, [_c('div', {
    staticClass: "container",
    staticStyle: {
      "max-width": "100%!important"
    }
  }, [_c('div', {
    staticClass: "w-25 ml-5"
  }, [_c('ul', {
    staticClass: "nav navbar-nav"
  }, [_c('button', {
    staticClass: "btn btn-xs menu-icon",
    style: ({
      'background-color': 'transparent'
    }),
    on: {
      "click": function($event) {
        _vm.toggleMenu()
      }
    }
  }, [_c('transition', {
    attrs: {
      "enter-active-class": "animated fadeIn slower",
      "leave-active-class": "animated rotateOut faster"
    }
  }, [(!_vm.showMenu) ? _c('img', {
    attrs: {
      "src": require("./assets/image/icon/menu.png"),
      "height": "50"
    }
  }) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "animated fadeIn slower",
      "leave-active-class": "animated rotateOut faster"
    }
  }, [(_vm.showMenu) ? _c('img', {
    attrs: {
      "src": require("./assets/image/icon/down_arrow.png"),
      "height": "50"
    }
  }) : _vm._e()])], 1)])]), _vm._v(" "), _c('router-link', {
    staticClass: "d-none d-md-block",
    class: {
      'navbar-brand': true, 'mx-auto': _vm.$route.path !== '/'
    },
    attrs: {
      "to": {
        name: _vm.user ? 'index' : 'login'
      }
    }
  }, [(_vm.locale === 'cn') ? _c('img', {
    attrs: {
      "src": require("./assets/image/logo_L_size(china).png"),
      "height": "50"
    }
  }) : _c('img', {
    attrs: {
      "src": require("./assets/image/logo_L_size.png"),
      "height": "50"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "w-25 d-flex justify-content-end mr-5",
    attrs: {
      "id": "navbarToggler1"
    }
  }, [_c('ul', {
    staticClass: "navbar-nav ml-auto"
  }, [(_vm.user) ? _c('li', {
    staticClass: "nav-item dropdown"
  }, [_c('a', {
    staticClass: "nav-link dropdown-toggle text-dark",
    attrs: {
      "data-toggle": "dropdown"
    },
    on: {
      "click": function($event) {
        _vm.toggleUserMenu()
      }
    }
  }, [_c('span', {
    staticClass: "displayUserName",
    style: ({
      'letter-spacing': '3px'
    })
  }, [_vm._v("Hi, " + _vm._s(_vm.user.realname))]), _vm._v(" "), (_vm.user.photo_url) ? _c('img', {
    staticClass: "rounded-circle profile-photo mr-1",
    attrs: {
      "src": _vm.user.photo_url,
      "height": "50"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.user.photo_url && _vm.user.rolename !== 'Teacher') ? _c('img', {
    staticClass: "rounded-circle profile-photo mr-1",
    attrs: {
      "src": require("./assets/image/icon/btn_user.png"),
      "height": "50"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.user.photo_url && _vm.user.rolename === 'Teacher') ? _c('img', {
    staticClass: "rounded-circle profile-photo mr-1",
    attrs: {
      "src": require("./assets/image/icon/btn_teacher.png"),
      "height": "50"
    }
  }) : _vm._e()]), _vm._v(" "), (false) ? _c('div', {
    staticClass: "dropdown-menu"
  }, [_c('div', {
    staticClass: "dropdown-divider"
  }), _vm._v(" "), _c('router-link', {
    staticClass: "dropdown-item pl-3",
    attrs: {
      "to": '/user/logout'
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('logout')) + "\n              ")])], 1) : _vm._e()]) : _c('li', {
    staticClass: "nav-item",
    style: ({
      'background-color': '#e1bc26',
      'width': '200px',
      'text-align': 'center'
    })
  }, [_c('a', {
    staticClass: "nav-link",
    style: ({
      'color': '#fff'
    }),
    attrs: {
      "active-class": "active"
    },
    on: {
      "click": function($event) {
        _vm.$modal.show('login-modal')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('login')) + " / " + _vm._s(_vm.$t('register')))])])])])], 1), _vm._v(" "), (_vm.showMenu || _vm.showUserMenu) ? _c('div', {
    staticClass: "w-100 animated fadeIn",
    attrs: {
      "id": "menu-layout"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.showUserMenu = false;
        _vm.showMenu = false
      }
    }
  }, [(_vm.showMenu) ? _c('div', {
    staticClass: "menu col-12 col-md-3",
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return (function () {
          return false
        })($event)
      }
    }
  }, [_c('ul', {
    staticClass: "nav flex-column nav-pills"
  }, _vm._l((_vm.menu), function(item, key) {
    return _c('li', {
      staticClass: "nav-item",
      on: {
        "click": function($event) {
          _vm.showMenu = false
        }
      }
    }, [_c('router-link', {
      staticClass: "nav-link",
      staticStyle: {
        "justify-content": "left"
      },
      attrs: {
        "to": '/' + key
      }
    }, [_vm._v("\n              " + _vm._s(_vm.$t(item.name)) + "\n            ")])], 1)
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.showUserMenu) ? _c('div', {
    staticClass: "menu menu-right col-12 col-md-3",
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return (function () {
          return false
        })($event)
      }
    }
  }, [_c('ul', {
    staticClass: "nav flex-column nav-pills"
  }, [_c('li', {
    staticClass: "nav-item",
    on: {
      "click": function($event) {
        _vm.showUserMenu = false
      }
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/user/password'
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('change_password')) + "\n            ")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item",
    on: {
      "click": function($event) {
        _vm.showUserMenu = false
      }
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/user/logout'
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('logout')) + "\n            ")])], 1)])]) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('router-view', {
    staticStyle: {
      "min-height": "calc(100vh - 160px)"
    }
  }), _vm._v(" "), _c('footer', {
    staticClass: "pb-3 pt-3"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row pt-3 pb-3"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "footer-title col-12 col-md-2 text-center"
  }, [_vm._v(_vm._s(_vm.$t('customer_service')))]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div'), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_vm._v("\n        服務電話：2660-0608 分機203｜客服時間：週一至週五 09:00~18:00｜客服信箱：dino_chu@liveabc.com\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_vm._v("\n        Copyright Hebron Soft Limited. All Rights Reserved.\n        ")]), _vm._v(" "), _c('div')])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-none d-md-block col-md-5"
  }, [_c('hr')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-none d-md-block col-md-5"
  }, [_c('hr')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-31ce5d9e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 722
// module chunks = 1